// extracted by mini-css-extract-plugin
export var details = "_gq-0";
export var inspectorPopover = "_gq-1";